/* eslint-disable radix */
/* eslint-disable no-plusplus */
/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { Col, Row, FormControl } from 'react-bootstrap';
import Select from 'react-select';
import { validateAccountNameRequest } from '../../requests/accountName';
import { createOnboardingRegistrationRequest } from '../../requests/onboardingRegistration';
import { setAccountName } from '../../actions/account';
import { clearOnboardingPaymentContext, saveOnboardingPaymentContext } from '../../data/platformPlans';
import image from '../../assets/images/index-bg-3.png';
import estudioRelieveLogo from '../../assets/images/estudio-relieve.jpeg';
import cottonPrintLogo from '../../assets/images/cotton_print_chile_logo.jpeg';
import resilityLogo from '../../assets/images/resility-logo.png';
import ganaderaBrangusLogo from '../../assets/images/ganadera-brangus-spa.webp';
import testimonialCards from '../../data/testimonials.json';
import OnboardingHeader from './OnboardingHeader';
import OnboardingStepper from '../../components/Onboarding/OnboardingStepper';
import PfInlineError from '../../components/Onboarding/PfInlineError';
import FormButtons from '../../components/Utils/Button/FormButtons';
import { isValidRutWithK, rutFormat } from '../../services/utils';

// Función para validar RUT chileno completo
const validateChileanRUT = rut => {
  if (!rut || rut.length < 11) return false;

  // Remover puntos y guiones
  const cleanRut = rut.replace(/\./g, '').replace(/-/g, '');

  // Separar número y dígito verificador
  const rutNumber = cleanRut.slice(0, -1);
  const rutDV = cleanRut.slice(-1).toLowerCase();

  // Calcular dígito verificador esperado
  const expectedDV = isValidRutWithK(rutNumber);

  // Comparar
  return rutDV === expectedDV.toLowerCase();
};

// Lista de países ordenada: Chile primero, México segundo, resto alfabético
const allCountries = [
  'Andorra',
  'United Arab Emirates',
  'Afghanistan',
  'Antigua and Barbuda',
  'Anguilla',
  'Albania',
  'Armenia',
  'Angola',
  'Antarctica',
  'Argentina',
  'American Samoa',
  'Austria',
  'Australia',
  'Aruba',
  'Aland Islands',
  'Azerbaijan',
  'Bosnia and Herzegovina',
  'Barbados',
  'Bangladesh',
  'Belgium',
  'Burkina Faso',
  'Bulgaria',
  'Bahrain',
  'Burundi',
  'Benin',
  'Saint Barthelemy',
  'Bermuda',
  'Brunei',
  'Bolivia',
  'Bonaire, Saint Eustatius and Saba ',
  'Brazil',
  'Bahamas',
  'Bhutan',
  'Bouvet Island',
  'Botswana',
  'Belarus',
  'Belize',
  'Canada',
  'Cocos Islands',
  'Democratic Republic of the Congo',
  'Central African Republic',
  'Republic of the Congo',
  'Switzerland',
  'Ivory Coast',
  'Cook Islands',
  'Chile',
  'Cameroon',
  'China',
  'Colombia',
  'Costa Rica',
  'Cuba',
  'Cape Verde',
  'Curacao',
  'Christmas Island',
  'Cyprus',
  'Czech Republic',
  'Germany',
  'Djibouti',
  'Denmark',
  'Dominica',
  'Dominican Republic',
  'Algeria',
  'Ecuador',
  'Estonia',
  'Egypt',
  'Western Sahara',
  'Eritrea',
  'Spain',
  'Ethiopia',
  'Finland',
  'Fiji',
  'Falkland Islands',
  'Micronesia',
  'Faroe Islands',
  'France',
  'Gabon',
  'United Kingdom',
  'Grenada',
  'Georgia',
  'French Guiana',
  'Guernsey',
  'Ghana',
  'Gibraltar',
  'Greenland',
  'Gambia',
  'Guinea',
  'Guadeloupe',
  'Equatorial Guinea',
  'Greece',
  'South Georgia and the South Sandwich Islands',
  'Guatemala',
  'Guam',
  'Guinea-Bissau',
  'Guyana',
  'Hong Kong',
  'Heard Island and McDonald Islands',
  'Honduras',
  'Croatia',
  'Haiti',
  'Hungary',
  'Indonesia',
  'Ireland',
  'Israel',
  'Isle of Man',
  'India',
  'British Indian Ocean Territory',
  'Iraq',
  'Iran',
  'Iceland',
  'Italy',
  'Jersey',
  'Jamaica',
  'Jordan',
  'Japan',
  'Kenya',
  'Kyrgyzstan',
  'Cambodia',
  'Kiribati',
  'Comoros',
  'Saint Kitts and Nevis',
  'North Korea',
  'South Korea',
  'Kosovo',
  'Kuwait',
  'Cayman Islands',
  'Kazakhstan',
  'Laos',
  'Lebanon',
  'Saint Lucia',
  'Liechtenstein',
  'Sri Lanka',
  'Liberia',
  'Lesotho',
  'Lithuania',
  'Luxembourg',
  'Latvia',
  'Libya',
  'Morocco',
  'Monaco',
  'Moldova',
  'Montenegro',
  'Saint Martin',
  'Madagascar',
  'Marshall Islands',
  'Macedonia',
  'Mali',
  'Myanmar',
  'Mongolia',
  'Macao',
  'Northern Mariana Islands',
  'Martinique',
  'Mauritania',
  'Montserrat',
  'Malta',
  'Mauritius',
  'Maldives',
  'Malawi',
  'Malaysia',
  'Mozambique',
  'Namibia',
  'New Caledonia',
  'Niger',
  'Norfolk Island',
  'Nigeria',
  'Nicaragua',
  'Netherlands',
  'Norway',
  'Nepal',
  'Nauru',
  'Niue',
  'New Zealand',
  'Oman',
  'Panama',
  'Peru',
  'French Polynesia',
  'Papua New Guinea',
  'Philippines',
  'Pakistan',
  'Poland',
  'Saint Pierre and Miquelon',
  'Pitcairn',
  'Puerto Rico',
  'Palestinian Territory',
  'Portugal',
  'Palau',
  'Paraguay',
  'Qatar',
  'Reunion',
  'Romania',
  'Serbia',
  'Russia',
  'Rwanda',
  'Saudi Arabia',
  'Solomon Islands',
  'Seychelles',
  'Sudan',
  'Sweden',
  'Singapore',
  'Saint Helena',
  'Slovenia',
  'Svalbard and Jan Mayen',
  'Slovakia',
  'Sierra Leone',
  'San Marino',
  'Senegal',
  'Somalia',
  'Suriname',
  'Sao Tome and Principe',
  'El Salvador',
  'Sint Maarten',
  'Syria',
  'Swaziland',
  'Turks and Caicos Islands',
  'Chad',
  'French Southern Territories',
  'Togo',
  'Thailand',
  'Tajikistan',
  'Tokelau',
  'East Timor',
  'Turkmenistan',
  'Tunisia',
  'Tonga',
  'Turkey',
  'Trinidad and Tobago',
  'Tuvalu',
  'Taiwan',
  'Tanzania',
  'Ukraine',
  'Uganda',
  'United States Minor Outlying Islands',
  'United States',
  'Uruguay',
  'Uzbekistan',
  'Vatican',
  'Saint Vincent and the Grenadines',
  'Venezuela',
  'British Virgin Islands',
  'U.S. Virgin Islands',
  'Vietnam',
  'Vanuatu',
  'Wallis and Futuna',
  'Samoa',
  'Yemen',
  'Mayotte',
  'South Africa',
  'Zambia',
  'Zimbabwe',
  'Serbia and Montenegro',
  'Netherlands Antilles',
  'México'
];

// Ordenar: Chile primero, México segundo, resto alfabético
const sortedCountries = ['Chile', 'México', ...allCountries.filter(c => c !== 'Chile' && c !== 'México').sort()];
const countryOptions = sortedCountries.map(country => ({ value: country, label: country }));

const STAR_RATINGS = [1, 2, 3, 4, 5];

const OnboardingIndex = ({ isTwistGo = false, isAccounting = false, isFreemium = false }) => {
  const [disableButton, setDisableButton] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(window.innerWidth <= 768 ? 1 : 2);
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  // Check if iframe mode is enabled
  const searchParams = new URLSearchParams(location.search);
  const isIframeMode = searchParams.get('format') === 'iframe';

  const account = useSelector(state => state.account);

  const [accountName, setAccountNameState] = useState(account.accountName || '');
  const [companyName, setCompanyName] = useState(account.companyName || '');
  // Si es accounting o freemium, siempre es Chile; si no, usar el del account o Chile por defecto
  const [country, setCountry] = useState(isAccounting || isFreemium ? 'Chile' : account.country || 'Chile');
  const [companyRUT, setCompanyRUT] = useState(account.companyRUT || '');
  const [errorMessage, setErrorMessage] = useState('');
  // Field-scoped errors ({ companyName, country, rut, accountName }) + the
  // prominent "RUT already registered" banner.
  const [fieldErrors, setFieldErrors] = useState({});
  const [rutTakenBanner, setRutTakenBanner] = useState(false);
  const [hasInteracted, setHasInteracted] = useState(false);
  const validAccountNameRegex = /^[a-zA-Z0-9-_]+$/;
  // The paid onboarding is now the ROOT flow; `/manual_onboarding` keeps the
  // legacy no-payment signup for the support team (decision 2026-07-09).
  const withPaymentFlow = location.pathname === '/' || location.pathname === '/onboarding';
  const requiresPayment = withPaymentFlow && !isAccounting && !isFreemium && !isTwistGo;

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setPageSize(mobile ? 1 : 2);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    // If we have initial data from redux, we want to run validation immediately
    if (account.accountName || account.companyName || account.companyRUT || account.country) {
      setHasInteracted(true);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!hasInteracted) return;

    // Same limits/conditions as always - only the messages and their placement
    // (per field, Claude Design) changed.
    const isAccountNameValid = accountName.length >= 4 && validAccountNameRegex.test(accountName);
    const isCompanyNameValid = companyName.trim().length > 0;
    const isCountryValid = country && country.trim().length > 0;

    // Determinar si el campo RUT/RFC/Identificador es válido
    const isChileanRut = country === 'Chile' || isAccounting || isFreemium;
    const isCompanyRUTValid = isChileanRut
      ? companyRUT.length >= 11 && validateChileanRUT(companyRUT)
      : companyRUT.trim().length > 0;

    const errors = {};
    if (!isCompanyNameValid) errors.companyName = 'El nombre de la empresa no puede estar vacío.';
    if (!isCountryValid) errors.country = 'Debes seleccionar un país.';
    if (!isCompanyRUTValid && isChileanRut && companyRUT.trim().length > 0) {
      errors.rut = 'RUT inválido. Revisa el número y el dígito verificador.';
    }
    if (!isAccountNameValid && accountName.length > 0) {
      errors.accountName =
        'Usa al menos 4 caracteres: solo letras, números o guiones, sin espacios ni caracteres especiales.';
    }

    setFieldErrors(errors);
    setDisableButton(!(isAccountNameValid && isCompanyNameValid && isCountryValid && isCompanyRUTValid));
  }, [accountName, companyName, country, companyRUT, hasInteracted, isAccounting, isFreemium]);

  useEffect(() => {
    const totalPages = Math.max(1, Math.ceil(testimonialCards.length / pageSize));
    setPageIndex(prev => (prev >= totalPages ? totalPages - 1 : prev));
  }, [pageSize]);

  const handleSuccess = res => {
    setIsLoading(false);
    if (!res.data.valid) {
      const serverError = res.data.error;
      setFieldErrors(prev => ({
        ...prev,
        accountName:
          serverError && !/utilizado/i.test(serverError)
            ? serverError
            : 'Este nombre de cuenta ya está en uso. Prueba con otro.'
      }));
      setDisableButton(true);
    } else {
      dispatch(
        setAccountName({
          ...account,
          accountName,
          companyRUT,
          companyName,
          country,
          twistgo: isTwistGo
        })
      );

      if (requiresPayment) {
        // Paid flow: everything lives server-side in a registration whose uuid
        // survives the Transbank redirect (mobile fix) - sessionStorage is
        // only a UX cache.
        createOnboardingRegistrationRequest({
          dispatch,
          params: {
            registration: {
              account_domain: accountName,
              company_name: companyName,
              company_rut: companyRUT,
              country
            }
          },
          successCallback: registrationResponse => {
            saveOnboardingPaymentContext({
              registrationId: registrationResponse.data.uuid,
              accountName,
              companyName,
              companyRUT,
              country
            });
            history.push({
              pathname: '/onboarding/plans',
              search: isIframeMode ? '?format=iframe' : ''
            });
          },
          failureCallback: error => {
            setIsLoading(false);
            const errors = error?.response?.data?.errors;
            if (error?.response?.status === 422 && errors?.some(message => /RUT/i.test(message))) {
              setRutTakenBanner(true);
            } else {
              setErrorMessage(errors?.length ? errors[0] : 'No fue posible iniciar el registro. Intenta nuevamente.');
            }
            setDisableButton(true);
          }
        });
        return;
      }

      clearOnboardingPaymentContext();

      history.push({
        pathname: '/account_register',
        search: isIframeMode ? '?format=iframe' : '',
        state: { isAccounting, isFreemium, isTwistGo, withPaymentFlow: false }
      });
    }
  };

  const handleAccountVerify = () => {
    setIsLoading(true);
    validateAccountNameRequest({
      dispatch,
      params: {
        account_name: accountName,
        company_rut: companyRUT,
        company_name: companyName,
        country
      },
      successCallback: res => handleSuccess(res),
      failureCallback: () => {
        setIsLoading(false);
        setErrorMessage('No fue posible validar la URL de tu cuenta. Intenta nuevamente.');
        setDisableButton(true);
      }
    });
  };

  const handleCompanyNameChange = e => {
    setHasInteracted(true);
    const companyNameValue = e.target.value;

    const formattedAccountName = companyNameValue.toLowerCase().replace(/[^a-z0-9]/g, '');

    setCompanyName(companyNameValue);
    setAccountNameState(formattedAccountName);
  };

  const handleInputChange = value => {
    setAccountNameState(value);
  };

  const handleCompanyRUTChange = e => {
    setHasInteracted(true);
    setRutTakenBanner(false);
    // Formatear con rutFormat si el país es Chile, es accounting o es freemium
    if (country === 'Chile' || isAccounting || isFreemium) {
      const formattedRUT = rutFormat(e.target.value.toUpperCase());
      setCompanyRUT(formattedRUT);
    } else {
      setCompanyRUT(e.target.value);
    }
  };

  const handleCountryChange = selectedOption => {
    setHasInteracted(true);
    setCountry(selectedOption ? selectedOption.value : '');
    // Limpiar el RUT cuando se cambia de país
    setCompanyRUT('');
  };

  const totalPages = Math.max(1, Math.ceil(testimonialCards.length / pageSize));
  const visibleTestimonials = testimonialCards.slice(pageIndex * pageSize, pageIndex * pageSize + pageSize);
  const placeholderCount = Math.max(0, pageSize - visibleTestimonials.length);

  const handleNextTestimonial = () => {
    setPageIndex(prev => (prev + 1) % totalPages);
  };

  const handlePrevTestimonial = () => {
    setPageIndex(prev => (prev - 1 + totalPages) % totalPages);
  };

  // Determinar el label y placeholder del campo RUT según el país
  const getRutLabel = () => {
    if (country === 'Chile' || isAccounting || isFreemium) return 'RUT Empresa';
    if (country === 'México') return 'RFC';
    return 'Identificador';
  };

  const getRutPlaceholder = () => {
    if (country === 'Chile' || isAccounting || isFreemium) return 'Ingresa RUT empresa';
    if (country === 'México') return 'Ingresa RFC';
    return 'Ingresa identificador';
  };

  const heroTitle = isTwistGo ? 'Crear cuenta Twist GO' : 'Bienvenido a Parrotfy';
  const landingHeroStyle = !isIframeMode ? { '--landing-hero-bg-url': `url(${image})` } : {};
  const showVideo = isFreemium && !isIframeMode;

  const testimonialsBlock = (
    <>
      <div className="onboarding-right__carousel-area">
        <h3 className="text-center users-title mb-3 mt-3 font-weight-bold">¿Qué dicen nuestros usuarios?</h3>
        <div className="onboarding-right__carousel-track mt-3 d-flex align-items-center justify-content-between w-100">
          <button
            type="button"
            onClick={handlePrevTestimonial}
            aria-label="Testimonio anterior"
            className="onboarding-right__carousel-button"
          >
            <span className="onboarding-right__carousel-icon">‹</span>
          </button>
          <div className="onboarding-right__testimonial-viewport">
            {visibleTestimonials.map(card => (
              <article
                key={`testimonial-${card.name}-${card.company}`}
                className="onboarding-right__testimonial mx-auto"
              >
                <div className="onboarding-right__testimonial-stars" aria-hidden="true">
                  {STAR_RATINGS.map(value => (
                    <span key={`star-${card.name}-${card.company}-${value}`} role="presentation">
                      ★
                    </span>
                  ))}
                </div>
                <p className="onboarding-right__testimonial-quote m-0">&ldquo;{card.quote}&rdquo;</p>
                <div className="onboarding-right__testimonial-meta mt-2">
                  <p className="mb-0">{card.name}</p>
                  <p className="mb-0">
                    {card.role}
                    {card.company ? `, ${card.company}` : ''}
                  </p>
                </div>
              </article>
            ))}
            {Array.from({ length: placeholderCount }, (_, index) => (
              <article
                key={`placeholder-${pageIndex}-${index}`}
                className="onboarding-right__testimonial onboarding-right__testimonial-placeholder"
                aria-hidden="true"
              />
            ))}
          </div>
          <button
            type="button"
            onClick={handleNextTestimonial}
            aria-label="Testimonio siguiente"
            className="onboarding-right__carousel-button"
          >
            <span className="onboarding-right__carousel-icon">›</span>
          </button>
        </div>
      </div>
    </>
  );

  const formColumn = (
    <div className="onboarding-card-stack d-flex flex-column mt-2">
      {!isIframeMode && (
        <div className="onboarding-card-stack__logo mb-1">
          <OnboardingHeader isTwistGo={isTwistGo} isIframeMode={isIframeMode} />
        </div>
      )}

      {!isIframeMode && (
        <div className="d-md-none onboarding-mobile-hero mb-3">
          <h2 className="users-title font-weight-bold mb-1 text-center">Haz que tu negocio no dependa de ti</h2>
          <p className="m-0 text-center onboarding-mobile-hero__subtitle">
            Conecta SII, bancos y previred para empezar a delegar las finanzas de tu negocio
          </p>
          {showVideo && (
            <section className="onboarding-right__video w-100 mx-auto mt-3">
              <div className="onboarding-right__videoWrapper">
                <div className="onboarding-right__videoStrip" aria-hidden="true">
                  <svg
                    className="onboarding-right__videoStrip-icon"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path d="M8 5v14l11-7L8 5zm2 5.07l4.44 2.51-4.44 2.52v-5.03z" />
                  </svg>
                  <span className="onboarding-right__videoStrip-text">Mira cómo funciona (1 min)</span>
                </div>
                <iframe
                  src="https://www.loom.com/embed/dff2445ceb5d4aca9f7c88f80faa01d6"
                  title="Parrotfy Freemium demo"
                  allow="autoplay; fullscreen; picture-in-picture"
                  allowFullScreen
                  loading="lazy"
                />
              </div>
            </section>
          )}
        </div>
      )}

      <div
        className={isIframeMode ? 'iframe-form' : `onboarding-card ${isFreemium ? 'onboarding-card--freemium' : ''}`}
      >
        {!isIframeMode && (
          <div className="d-md-none onboarding-card__intro text-center">
            <h3 className="font-weight-bold mb-1">Crea tu cuenta</h3>
          </div>
        )}

        {!isIframeMode && (
          <div className="d-none d-md-block onboarding-card__intro">
            {requiresPayment && <OnboardingStepper current={1} />}
            <h1 className="pf-card__title mb-1">{heroTitle}</h1>
            <p className="pf-card__subtitle m-0">Crea tu cuenta y obtén tu estado de resultados en minutos.</p>
          </div>
        )}

        <div className="onboarding-card__form mt-3">
          {rutTakenBanner && (
            <div className="pf-banner-error" role="alert">
              <svg
                className="pf-banner-error__icon"
                width="17"
                height="17"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
              >
                <circle cx="12" cy="12" r="10" />
                <path d="M12 8v4M12 16h.01" />
              </svg>
              <div>
                <p className="pf-banner-error__title">Este RUT ya tiene un plan activo</p>
                <p className="pf-banner-error__body">
                  La empresa <strong>{companyRUT}</strong> ya está registrada en Parrotfy. Inicia sesión o usa otro RUT
                  para crear una cuenta nueva.
                </p>
              </div>
            </div>
          )}

          <div className="onboarding-card__field mb-3">
            <span className="pf-label">Nombre de la empresa</span>
            <FormControl
              className={`pf-field ${fieldErrors.companyName ? 'pf-field--error' : ''}`}
              placeholder="Ej. Comercial Los Robles SpA"
              value={companyName}
              onChange={handleCompanyNameChange}
            />
            {fieldErrors.companyName && <PfInlineError>{fieldErrors.companyName}</PfInlineError>}
          </div>

          <div className="pf-field-row mb-3">
            {!isAccounting && !isFreemium && (
              <div>
                <span className="pf-label">País</span>
                <Select
                  options={countryOptions}
                  value={countryOptions.find(option => option.value === country)}
                  onChange={handleCountryChange}
                  placeholder="Selecciona"
                  isSearchable
                  styles={{
                    container: provided => ({ ...provided, width: '100%' }),
                    control: provided => ({
                      ...provided,
                      borderRadius: '12px',
                      borderWidth: '1.5px',
                      borderColor: '#dfdfdf',
                      minHeight: '46px'
                    })
                  }}
                  classNamePrefix="onboarding-select"
                />
              </div>
            )}
            <div>
              <span className="pf-label">{isAccounting || isFreemium ? 'RUT de la empresa' : getRutLabel()}</span>
              <FormControl
                className={`pf-field ${fieldErrors.rut ? 'pf-field--error' : ''}`}
                placeholder={isAccounting || isFreemium ? '76.123.456-7' : getRutPlaceholder()}
                value={companyRUT}
                onChange={handleCompanyRUTChange}
              />
              {fieldErrors.rut && <PfInlineError>{fieldErrors.rut}</PfInlineError>}
            </div>
          </div>

          <div className="onboarding-card__field mb-3">
            <span className="pf-label">
              URL de tu cuenta <small>(enlace de acceso)</small>
            </span>
            <div className={`pf-field-group ${fieldErrors.accountName ? 'pf-field-group--error' : ''}`}>
              <input
                type="text"
                placeholder="tu-empresa"
                value={accountName}
                onChange={e => handleInputChange(e.target.value)}
              />
              <span className="pf-field-group__suffix">.parrotfy.com</span>
            </div>
            {fieldErrors.accountName && <PfInlineError>{fieldErrors.accountName}</PfInlineError>}
          </div>

          {hasInteracted && errorMessage && (
            <div className="onboarding-card__field mb-3">
              <PfInlineError>{errorMessage}</PfInlineError>
            </div>
          )}
        </div>

        <div className="onboarding-card__form-actions onboarding-card__form-actions--hero d-flex flex-column">
          <FormButtons
            disabledSuccess={disableButton}
            saveTitle="Crear mi cuenta ahora"
            saveOnClick={handleAccountVerify}
            isLoading={isLoading}
            size="lg"
            saveButtonClassName="onboarding-create-account-btn pf-btn pf-btn--gradient pf-btn--block"
            justify="center"
          />
          {!isIframeMode && !requiresPayment && (
            <p className="onboarding-card__credit-note mt-1 text-center">No se requiere tarjeta de crédito</p>
          )}
        </div>

        {!isIframeMode && (
          <>
            <div className="pf-divider" />
            <div className="onboarding-left__trusted text-center">
              <p className="pf-trust__title mb-2">+500 empresas ya confían en Parrotfy</p>
              <div className="onboarding-left__logos d-flex justify-content-center align-items-center flex-wrap mb-2">
                <img src={estudioRelieveLogo} alt="Estudio Relieve" />
                <img src={cottonPrintLogo} alt="Cotton Print Chile" />
                <img src={resilityLogo} alt="Resility" />
                <img src={ganaderaBrangusLogo} alt="Ganadera Brangus" />
              </div>
            </div>
          </>
        )}
      </div>

      {!isIframeMode && <div className="d-md-none onboarding-mobile-testimonials mt-4">{testimonialsBlock}</div>}
    </div>
  );

  return (
    <>
      <div
        className={isIframeMode ? 'onboarding-page onboarding-page--iframe' : 'onboarding-page landing-hero'}
        style={!isIframeMode ? landingHeroStyle : undefined}
      >
        {!isIframeMode && (
          <>
            <div className="landing-hero__bg" />
            <div className="landing-hero__wash" />
            <div className="landing-hero__darken" />
            <div className="landing-hero__tint" />
          </>
        )}
        <div
          className={
            isIframeMode
              ? 'onboarding-page__content d-flex align-items-center justify-content-between'
              : 'landing-hero__content d-flex align-items-center justify-content-between'
          }
        >
          {isIframeMode ? (
            <div className="iframe-column">{formColumn}</div>
          ) : (
            <Row className="justify-content-center align-items-start" noGutters>
              <Col xs={12} md={4} className="pl-md-2 pr-2 pl-2 col-md-4 col-12">
                {formColumn}
              </Col>
              <Col
                xs={12}
                md={8}
                className="onboarding-right-col d-none d-md-flex align-items-stretch justify-content-center"
              >
                <div className="onboarding-right d-flex flex-column">
                  <div className="onboarding-right__intro text-center">
                    <h2 className="users-title font-weight-bold mb-1">Haz que tu negocio no dependa de ti</h2>
                    <p className="m-0">
                      Conecta SII, bancos y previred para empezar a delegar las finanzas de tu negocio
                    </p>
                  </div>

                  {showVideo && (
                    <section className="onboarding-right__video w-100 mx-auto">
                      <div className="onboarding-right__videoWrapper">
                        <div className="onboarding-right__videoStrip" aria-hidden="true">
                          <svg
                            className="onboarding-right__videoStrip-icon"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                            aria-hidden="true"
                          >
                            <path d="M8 5v14l11-7L8 5zm2 5.07l4.44 2.51-4.44 2.52v-5.03z" />
                          </svg>
                          <span className="onboarding-right__videoStrip-text">Mira cómo funciona (1 min)</span>
                        </div>
                        <iframe
                          src="https://www.loom.com/embed/dff2445ceb5d4aca9f7c88f80faa01d6"
                          title="Parrotfy Freemium demo"
                          allow="autoplay; fullscreen; picture-in-picture"
                          allowFullScreen
                          loading="lazy"
                        />
                      </div>
                    </section>
                  )}

                  {testimonialsBlock}
                </div>
              </Col>
            </Row>
          )}
        </div>
      </div>
    </>
  );
};

export default OnboardingIndex;
